import { useLocalStorage } from '@vueuse/core';
export const defaultAlertsOptions = Object.freeze({
    alerts: ['Ashby', 'TTC'],
    resolve: true,
});
export const defaultAlertsDisplaySettings = Object.freeze({
    collapse: false,
    showDetails: false,
    showImages: false,
    showEmpty: false,
});
const LEGACY_VUEX_STORAGE_KEY = 'vuex';
const migrateLegacyAlertsPreferences = () => {
    if (typeof window === 'undefined' || typeof window.localStorage === 'undefined')
        return;
    try {
        const rawLegacyStore = window.localStorage.getItem(LEGACY_VUEX_STORAGE_KEY);
        if (!rawLegacyStore)
            return;
        const parsedLegacyStore = JSON.parse(rawLegacyStore);
        const legacyAlerts = parsedLegacyStore?.alerts;
        if (!legacyAlerts || !('stateAlertsOptions' in legacyAlerts))
            return;
        if (legacyAlerts.stateAlertsOptions && !window.localStorage.getItem('alerts.options')) {
            window.localStorage.setItem('alerts.options', JSON.stringify(legacyAlerts.stateAlertsOptions));
        }
        const nextLegacyAlerts = { ...legacyAlerts };
        delete nextLegacyAlerts.stateAlertsOptions;
        window.localStorage.setItem(LEGACY_VUEX_STORAGE_KEY, JSON.stringify({
            ...parsedLegacyStore,
            alerts: nextLegacyAlerts,
        }));
    }
    catch {
        // Keep defaults when storage is unavailable or contains invalid data.
    }
};
migrateLegacyAlertsPreferences();
export const alertsOptionsPreference = useLocalStorage('alerts.options', { ...defaultAlertsOptions, alerts: [...defaultAlertsOptions.alerts] }, { mergeDefaults: true });
export const alertsDisplaySettingsPreference = useLocalStorage('alerts.display-settings', { ...defaultAlertsDisplaySettings }, { mergeDefaults: true });
